const siteConfig = {
  SE: {
    storyblokLanguage: 'default',
    locale: 'sv-SE',
    ethelLanguage: 'SV',
    i18nLanguage: 'sv',
    ethelMarket: 'SE',
    ethelBookingURL: 'https://booking.alpresor.se',
    companyName: 'STS Alpresor',
    legalName: 'STS Alpresor AB',
    siteUrl: 'https://www.alpresor.se',
    profileURL: 'min-resa',
    searchPage: '/sok-resa',
  },
  FI: {
    market: 'FI',
    locale: 'fi-FI',
    i18nLanguage: 'fi',
    storyblokLanguage: 'fi',
    ethelLanguage: 'FI',
    ethelMarket: 'FI',
    ethelBookingURL: 'https://booking.alppimatkat.fi',
    companyName: 'STS Alppimatkat',
    legalName: 'STS Alppimatkat Oy',
    siteUrl: 'https://www.alppimatkat.fi',
    profileURL: 'minun-matkani',
    searchPage: '/etsi-matka',
  },
  NO: {
    market: 'NO',
    locale: 'nb-NO',
    i18nLanguage: 'no',
    storyblokLanguage: 'no',
    ethelLanguage: 'NO',
    ethelMarket: 'NO',
    ethelBookingURL: 'https://booking.alpereiser.no',
    companyName: 'STS Alpereiser',
    legalName: 'STS Alpereiser AS',
    siteUrl: 'https://www.alpereiser.no',
    profileURL: 'min-reise',
    searchPage: '/sok-reise',
  },
};

const getSiteConfig = () => {
  const market = process.env.GATSBY_SITE || 'SE';
  // const market = 'FI';
  // const market = 'NO';
  return siteConfig[market];
};

exports.getSiteConfig = getSiteConfig;
